import { t } from "../lib/i18n";
import type { ButtonHTMLAttributes, InputHTMLAttributes, ReactNode } from "react";

export function Field({ label, hint, ...props }: { label: string; hint?: string } & InputHTMLAttributes<HTMLInputElement>) {
  const id = props.id ?? props.name;
  return (
    <label htmlFor={id} className="block text-sm">
      <span className="font-medium">{label}</span>
      <input
        id={id}
        {...props}
        className="mt-1 block w-full rounded-lg border border-surface-line bg-card px-3 py-2 text-base focus:border-brand"
      />
      {hint && <span className="mt-1 block text-xs text-muted">{hint}</span>}
    </label>
  );
}

export function Button({
  children,
  busy,
  variant = "primary",
  ...props
}: { children: ReactNode; busy?: boolean; variant?: "primary" | "secondary" | "danger" } & ButtonHTMLAttributes<HTMLButtonElement>) {
  const styles = {
    primary: "bg-brand text-white hover:bg-brand-dark",
    secondary: "border border-surface-line bg-card text-brand-ink",
    danger: "bg-red-600 text-white hover:bg-red-700",
  }[variant];
  return (
    <button
      {...props}
      disabled={busy || props.disabled}
      aria-busy={busy}
      className={`rounded-lg px-4 py-2 text-sm font-semibold disabled:opacity-60 ${styles} ${props.className ?? ""}`}
    >
      {busy ? t("Sila tunggu…") : children}
    </button>
  );
}

export function Alert({ kind, children }: { kind: "error" | "success" | "info"; children: ReactNode }) {
  const styles = { error: "bg-red-50 text-red-800", success: "bg-emerald-50 text-emerald-900", info: "bg-surface-muted text-brand-ink" }[kind];
  return (
    <p role={kind === "error" ? "alert" : "status"} className={`rounded-lg p-3 text-sm ${styles}`}>
      {children}
    </p>
  );
}
